import { LayoutColors, colors } from '@src/core/theme';
import styled from 'styled-components';
import useTranslate from '@src/i18n/useTranslate';
import { BodyRegular, BodyRegularSemiBold, Heading6 } from '@src/fonts/typography/Typography';
import { useAppDispatch } from '@src/core/hooks';
import React from 'react';
import { device } from '@src/common/breakpoints';
import { setRequestTimeout } from '@src/features/ui';

export const TimeoutModal = () => {
  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();

  return (
    <Container>
      <Content>
        <Texts>
          <Title>{i18n('timeout_error_title')}</Title>

          <Description>{i18n('timeout_error_description')}</Description>
        </Texts>

        <OkButton onClick={() => dispatch(setRequestTimeout(false))}>{i18n('timeout_error_ok')}</OkButton>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Content = styled.div`
  border-radius: 8px;
  background-color: ${LayoutColors.whiteLight};
  padding: 8px;
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  margin: auto;

  ${device.mediumTablet} {
    gap: 24px;
  }
`;

const OkButton = styled.button`
  width: 100%;
  background-color: ${colors.primary[500]};
  height: 44px;
  ${BodyRegularSemiBold};
  border-radius: 4px;
  padding: 8px;
  color: ${LayoutColors.whiteLight};
  cursor: pointer;
  border: none;
  border-style: none;
`;

const Texts = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 16px;
`;

const Title = styled.h6`
  ${Heading6};

  color: ${colors.primary[500]};
`;

const Description = styled.p`
  ${BodyRegular};
  color: ${colors.grey[700]};
`;
